export default () => {



  const showMessage = (text) => {
    const message = document.getElementById('order_status');
    message.textContent = text;
    message.classList.add('active');
    setTimeout(() => {
      message.classList.remove('active');
      document.getElementById('back').click();
    }, 800);
  };

  const saveuser = () => {
    const data = new FormData();
    data.append('id', document.getElementById('user-id').value);
    data.append('name', document.getElementById('user-name').value);
    data.append('phone', document.getElementById('user-phone').value);
    data.append('mid', document.getElementById('user-mid').value);
    data.append('code', document.querySelector('input[name="code"]:checked').value);
    fetch('/dsb/user/update', {
      method: 'POST',
      body: data
    })
    .then(result => result.text())
    .then(result => showMessage(result))
  }

  const deleteuser = () => {
    const data = new FormData();
    data.append('id', document.getElementById('user-id').value);
    fetch('/dsb/user/delete', {
      method: 'POST',
      body: data
    })
    .then(result => result.text())
    .then(result => showMessage(result))
  }

  console.log(window.location.pathname);
  if (window.location.pathname == '/dsb/user/new') {
    document.getElementById('add_user').addEventListener('click', saveuser, false);
  } else {
    document.getElementById('update_user').addEventListener('click', saveuser, false);
    document.getElementById('delete_user').addEventListener('click', deleteuser, false);
  }
}
